import * as React from 'react';
import clsx from 'clsx';
import { extend, colord } from 'colord';
import { Colors } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import '../../../theme/Typography.es.js';

var o=function(o){var t=o/255;return t<.04045?t/12.92:Math.pow((t+.055)/1.055,2.4)},t=function(t){return .2126*o(t.r)+.7152*o(t.g)+.0722*o(t.b)};function a11yPlugin(o){o.prototype.luminance=function(){return o=t(this.rgba),void 0===(r=2)&&(r=0),void 0===n&&(n=Math.pow(10,r)),Math.round(n*o)/n+0;var o,r,n;},o.prototype.contrast=function(r){void 0===r&&(r="#FFF");var n,a,i,e,v,u,d,c=r instanceof o?r:new o(r);return e=this.rgba,v=c.toRgb(),u=t(e),d=t(v),n=u>d?(u+.05)/(d+.05):(d+.05)/(u+.05),void 0===(a=2)&&(a=0),void 0===i&&(i=Math.pow(10,a)),Math.floor(i*n)/i+0},o.prototype.isReadable=function(o,t){return void 0===o&&(o="#FFF"),void 0===t&&(t={}),this.contrast(o)>=(e=void 0===(i=(r=t).size)?"normal":i,"AAA"===(a=void 0===(n=r.level)?"AA":n)&&"normal"===e?7:"AA"===a&&"large"===e?3:4.5);var r,n,a,i,e;};}

const root = "_root_1rexh_1";
const styles = {
	root: root
};

extend([a11yPlugin]);
const Tag = ({ children, className, size = "small", variant = "default" }) => {
  let backgroundColor = "UiPrimaryWeaker";
  let textColor = "TextDefault";
  if (!isTagVariant(variant)) {
    backgroundColor = variant;
    const lightTextContrast = colord(Colors[backgroundColor]).contrast(Colors.TextInverted);
    const darkTextContrast = colord(Colors[backgroundColor]).contrast(Colors.TextStronger);
    if (lightTextContrast > darkTextContrast) {
      textColor = "TextInverted";
    } else {
      textColor = "TextStronger";
    }
  }
  return React.createElement("span", { className: clsx(styles.root, className), style: {
    "--zds-internal-tag-background": Colors[backgroundColor],
    "--zds-internal-tag-text": Colors[textColor]
  }, "data-size": size, "data-variant": variant, "data-zds": true }, children);
};
const tagVariants = [
  "default",
  "success",
  "error",
  "warning",
  "inverted",
  "simple"
];
const tagVariantsSet = new Set(tagVariants);
function isTagVariant(variant) {
  return tagVariantsSet.has(variant);
}

export { Tag };
//# sourceMappingURL=Tag.es.js.map
